<template lang="pug">
div(class="container")
  div(class="card")
    header(class="card-header")
      p(class="card-header-title") Merchants
    div(class="card-content")
      div(class="content")
        nx-table(
          ref="nxTable"
          url-add="merchant/add"
          url-edit="merchant/edit"
          url-fetch="merchant/list"
          url-delete="merchant/delete"
          :selected-columns="selectedColumns"
          :checkable="true"
          @fillEdit="fill($event)"
        )
          template(#form="props")
            div(class="modal-card" style="width: auto; min-width: 40vw;")
              header(class="modal-card-head")
                p(class="modal-card-title")  {{ props.modeAdd ? 'Add merchant' : 'Edit merchant' }}
              section(class="modal-card-body")
                b-field(label="displayname")
                  b-input(
                    v-model="formData.displayname"
                    type="string"
                    placeholder="displayname"
                    required
                  )
                b-field(label="cosApi")
                  b-input(
                    v-model="formData.cosApi"
                    type="string"
                    placeholder="cosApi"
                    required
                  )
                b-field(label="xAuthAppId")
                  b-input(
                    v-model="formData.xAuthAppId"
                    type="string"
                    placeholder="xAuthAppId"
                    required
                  )
                b-field(label="cosUser")
                  b-input(
                    v-model="formData.cosUser"
                    type="string"
                    placeholder="cosUser"
                    required
                  )
                b-field(label="cosPwd")
                  b-input(
                    v-model="formData.cosPwd"
                    type="string"
                    placeholder="cosPwd"
                    required
                  )
                b-field(label="nxToken")
                  b-input(
                    v-model="formData.nxToken"
                    type="string"
                    placeholder="nxToken"
                    required
                  )
                b-field(
                  v-if="nxTokenColumns && nxTokenData"
                )
                  b-table(
                    :columns="nxTokenColumns"
                    :data="nxTokenData"
                  )
                b-field(v-if="!props.modeAdd" label="c1Token")
                  b-input(
                    v-model="formData.c1Token"
                    type="string"
                    placeholder="c1Token"
                    required
                  )
                b-field(label="heartbeatSystem")
                  b-input(
                    v-model="formData.heartbeatSystem"
                    type="string"
                    placeholder="heartbeatSystem"
                    required
                  )
                b-field(label="heartbeatKey")
                  b-input(
                    v-model="formData.heartbeatKey"
                    type="string"
                    placeholder="heartbeatKey"
                    required
                  )
                b-field(label="FIELD")
                  b-input(
                    v-model="formData.FIELD"
                    type="string"
                    placeholder="FIELD"
                    required
                  )
                b-field(label="debugMode")
                  b-checkbox(
                    v-model="formData.debugMode"
                  )
                b-field(label="noWriteToCOS")
                  b-checkbox(
                    v-model="formData.noWriteToCOS"
                  )
                b-field(label="enablePriceUpdate")
                  b-checkbox(
                    v-model="formData.enablePriceUpdate"
                  )
                b-field(label="pauseTime")
                  b-input(
                    v-model="formData.pauseTime"
                    type="string"
                    placeholder="pauseTime"
                    required
                  )
                b-field
                  template(#label)
                    div.is-flex.is-flex-direction-row.is-align-content-center
                      span disableDefaultFinancing
                      b-tooltip(position="is-right" multilined)
                        b-icon(icon="information-outline")
                        template(#content)
                          | Payment types named "Finanzierung" are no longer
                          | treated as a payment automatically. Payment types
                          | listed in the financing config below are unaffected.
                  b-checkbox(
                    v-model="formData.disableDefaultFinancing"
                  )
                b-field
                  template(#label)
                    div.is-flex.is-flex-direction-row.is-align-content-center
                      span ignorePrefixedFields
                      b-tooltip(position="is-right" multilined)
                        b-icon(icon="information-outline")
                        template(#content)
                          | Payment types starting with FIELD are ignored
                          | instead of being counted as an asset. Only the
                          | payment type matching FIELD exactly is written to.
                  b-checkbox(
                    v-model="formData.ignorePrefixedFields"
                  )
                b-field
                  template(#label)
                    div.is-flex.is-flex-direction-row.is-align-content-center
                      span Financing
                      b-tooltip(position="is-right" multilined)
                        b-icon(icon="information-outline")
                        template(#content)
                          strong.has-text-white Example
                          pre(style="text-align: left") {{ JSON.stringify(financingExample, null, 2) }}
                  vue-json-editor(
                    v-model="formData.financingConfig"
                    :expanded-on-start="true"
                  )

              footer(class="modal-card-foot")
                b-button(
                  label="Close"
                  icon-left="close"
                  @click="$refs.nxTable.close()"
                )
                b-button(
                  label="Save"
                  icon-left="plus"
                  type="is-primary"
                  @click="$refs.nxTable.save(formData)"
                )
                b-message(v-if="props.error" title="error") {{ props.error }}

    footer(class="card-footer")
</template>

<script>
import vueJsonEditor from 'vue-json-editor';
import moment from 'moment';
import nxTable from '@nx-t/vue-components/vue2/nxTableOld';

export default {
  components: {
    nxTable,
    vueJsonEditor,
  },
  data() {
    return {
      selectedColumns: [
        'displayname', 'cosApi', 'xAuthAppId', 'cosUser',
        'FIELD', 'debugMode', 'noWriteToCOS', 'enablePriceUpdate',
      ],
      formData: {
        displayname: '',
        cosApi: '',
        xAuthAppId: 'NxTechnologies_bezahl.de',
        cosUser: '',
        cosPwd: '',
        nxToken: '',
        nxTokenRaw: '',
        c1Token: '',
        heartbeatSystem: '',
        heartbeatKey: '',
        financingConfig: {},
        disableDefaultFinancing: false,
        ignorePrefixedFields: false,
        FIELD: 'bezahl.de',
        debugMode: false,
        noWriteToCOS: false,
        enablePriceUpdate: false,
        pauseTime: '02:00-04:00',
      },
      financingExample: {
        Finanzierung: {
          'received?': true,
        },
      },
    };
  },
  computed: {
    nxTokenData() {
      if (this.formData.nxTokenRaw && typeof this.formData.nxTokenRaw === 'object') {
        const token = this.formData.nxTokenRaw;
        return [
          {
            owner: token.email,
            exp: token.exp ? moment.unix(token.exp).format('LLL') : '',
            expired: this.isTokenExpired(token),
          },
        ];
      }

      return undefined;
    },
    nxTokenColumns() {
      if (!this.nxTokenData) {
        return undefined;
      }

      return [
        {
          field: 'owner',
          label: 'Owner',
          headerClass: this.nxTokenData?.[0]?.expired ? 'token-expired' : undefined,
          cellClass: this.nxTokenData?.[0]?.expired ? 'token-expired' : undefined,
        },
        {
          field: 'exp',
          label: 'Expiration Date',
          headerClass: this.nxTokenData?.[0]?.expired ? 'token-expired' : undefined,
          cellClass: this.nxTokenData?.[0]?.expired ? 'token-expired' : undefined,
        },
      ];
    },
  },
  methods: {
    fill(editData) {
      this.formData = {
        ...editData,
        nxToken: typeof editData.nxToken === 'string' ? editData.nxToken : '',
        nxTokenRaw: editData.nxToken,
        disableDefaultFinancing: editData.disableDefaultFinancing ?? false,
        ignorePrefixedFields: editData.ignorePrefixedFields ?? false,
      };

      if (!this.formData.financingConfig) {
        this.formData.financingConfig = {};
      }
    },
    isTokenExpired(token) {
      return token
        && typeof token === 'object'
        && moment().isAfter(moment.unix(token.exp || 0));
    },
  },
};

</script>
